export const LAST_FLOOR_STORAGE_KEY = "lastFloorId";
export const DASHBOARD_SELECTED_OFFICES_STORAGE_KEY =
  "dashboard_selected_offices";

export const RESERVATION_PERIOD_EXTENSION_BY_EMAIL: Record<string, number> = {
  "nikola.fuckova@moodys.com": 3
};

export function getReservationExtensionDays(
  userEmail: string | undefined | null
): number {
  if (!userEmail) return 0;
  return RESERVATION_PERIOD_EXTENSION_BY_EMAIL[userEmail.toLowerCase()] ?? 0;
}
